var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.image},[_c('BaseImage',{attrs:{"src":_vm.src && _vm.src !== '' ? _vm.src : _vm.fallbackImage,"alt":_vm.alt,"fallback-image":_vm.fallbackImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }